function formatNumber(number) {
  if (number > 1e3) {
    return Math.round(number);
  }

  if (number > 1) {
    return number.toPrecision(3);
  }

  return number.toFixed(2);
}

/**
 * Get result of specified test.
 *
 * @param {object} results Results from speed test library.
 * @param {string} test Name of test.
 * @returns {{ val: number, unit: string }|{}} Value and unit.
 */
export default function getResult(results, test = results.inProgress) {
  if (!test) {
    return { val: undefined, unit: undefined };
  }

  if (test === 'jitter') {
    if (results.latency.jitter >= 1e6) {
      return {
        val: formatNumber(results.latency.jitter / 1e6),
        unit: 's',
      };
    }
    return {
      val: formatNumber(results.latency.jitter / 1e3),
      unit: 'ms',
    };
  }

  if (test === 'latency') {
    if (results.latency.round_trip_time >= 1e6) {
      return {
        val: formatNumber(results.latency.round_trip_time / 1e6),
        unit: 's',
      };
    }
    return {
      val: formatNumber(results.latency.round_trip_time / 1e3),
      unit: 'ms',
    };
  }

  let val = results[test].mbps || 0;
  let unit = 'mbps';

  if (val < 1) {
    val *= 1024;
    unit = 'kbps';
  }

  return { val: formatNumber(val), unit };
}



// WEBPACK FOOTER //
// ./src/js/lib/get-result.js